import { SyntheticEvent, useRef } from "react";
import {
  ButtonGroup,
  Box,
  FormControl,
  FormHelperText,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import SrInput from "../SrInput/SrInput";
import SrButton from "../SrButton/SrButton";
import SrLabel from "../SrLabel/SrLabel";

type SrFileInputProps = {
  label?: Node;
  name?: string;
  helperText?: string;
  buttonLabel?: Node;
  placeholder?: string;
  onChange?: (event: SyntheticEvent<HTMLInputElement>) => void;
  onBlur?: (event: SyntheticEvent<HTMLInputElement>) => void;
  error?: boolean;
  value?: { file: { name: string } };
};

const useStyles = makeStyles((theme) => ({
  fullWidth: {
    width: "100%",
  },
  inputButton: {
    "& .MuiBox-root": {
      width: "100%",
    },
    "& .MuiInputBase-root": {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
      "& input": {
        cursor: "pointer",
      },
    },
    "& .MuiButton-root": {
      borderTopRightRadius: theme.shape.borderRadius,
      borderBottomRightRadius: theme.shape.borderRadius,
      border: `1px solid ${theme.palette.divider}`,
    },
  },
  hidden: {
    opacity: 0,
    width: 0,
    height: 0,
    overflow: "hidden",
    position: "absolute",
  },
}));

const SrFileInput = ({
  label,
  name,
  helperText,
  buttonLabel,
  placeholder,
  onChange,
  onBlur,
  error,
  value,
  ...props
}: SrFileInputProps) => {
  const classes = useStyles();
  const fileInputEl = useRef<HTMLInputElement>(null);

  const internalName = `${name}-display`;

  const onInputClick = () => {
    if (fileInputEl && fileInputEl.current) {
      fileInputEl.current.click();
    }
  };

  return (
    <FormControl fullWidth>
      {label && <SrLabel name={name}>{label}</SrLabel>}
      <Box width="100%" mt={label ? 1 : ""}>
        <ButtonGroup
          className={[classes.fullWidth, classes.inputButton].join(" ")}
        >
          <SrInput
            InputProps={{
              readOnly: true,
            }}
            className={classes.fullWidth}
            label={undefined}
            id={internalName}
            name={internalName}
            placeholder={placeholder}
            value={(value && value.file.name) || ""}
            error={error}
            fullWidth
            onClick={onInputClick}
          />
          <SrButton htmlFor={name} variant="contained" component="label">
            {buttonLabel}
          </SrButton>
          <input
            ref={fileInputEl}
            className={classes.hidden}
            name={name}
            id={name}
            type="file"
            onChange={onChange}
            onBlur={onBlur}
          />
        </ButtonGroup>
        <FormHelperText error id={name}>
          {helperText}
        </FormHelperText>
      </Box>
    </FormControl>
  );
};

export default SrFileInput;
